import { Injectable }  from '@angular/core';
import { Http }  from '@angular/http';

import { BaseService } from './base.service';
import { CookieUtils } from '../shared/cookieutils';
import { BaseServiceExceptionHandler } from './base-service-exception-handler';

@Injectable()
export class GetAccountByUsernameService extends BaseService {

	constructor($http: Http, $cookies: CookieUtils, BaseServiceExceptionHandler: BaseServiceExceptionHandler) {
		super($http, $cookies, BaseServiceExceptionHandler);
	}

    public get(requestObj) {
		let urlStr: string = 'account/' + requestObj.username;

		return this.sendRequest('GET',
			urlStr,
			null,
			null,
			true);
    }

}
